import React from "react";
import { connect } from "react-redux";
import { Link } from 'react-router';
import _ from "lodash";

// Not found page component
class NotFound extends React.Component {
  homeRoute() {
    if (!this.props.currentUser || !this.props.currentUser.perfis) {
      return "/secure";
    }
    if (_.findIndex(this.props.currentUser.perfis, (perfil) => perfil === "DETRAN") > -1) {
      return "/sdetran";
    }
    if (_.findIndex(this.props.currentUser.perfis, (perfil) => perfil === "ALIAS") > -1) {
      return "/alias";
    }
    return "/secure";
  }

  // render
  render() {
    const homeRoute = this.homeRoute();
    return (
      <div>
      <div className="color-line-ereg"></div>

<div className="back-link">
    <Link to={homeRoute} className="btn btn-primary">Tela Inicial</Link>
</div>
<div className="error-container">
    <i className="pe-7s-way text-success big-icon"></i>
    <h1>404</h1>
    <strong>Página Não Encontrada</strong>
    <p>
        Não conseguimos encontrar a página que você procurava.
    </p>
    <Link to={homeRoute} className="btn btn-xs btn-success">Voltar à tela inicial</Link>
</div>
</div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentUser: state.common.currentUser,
});

export default connect(mapStateToProps)(NotFound);
